
/**
 * @returns {Array} - [{siganlName, isVictim}]
 */
function getSignalNameObjByVerificationJson(verificationJson) {
  if (!verificationJson || !verificationJson.Interfaces || !verificationJson.Interfaces.length) {
    return {};
  }

  const { Interfaces } = verificationJson;
  const signalObj = {};
  for (const { content } of Interfaces) {
    const { signals } = content;
    for (const { name, isVictim, nets } of signals) {
      if (!signalObj[name]) {
        signalObj[name] = { signalName: name, isVictim, nets };
      }
    }
  }

  return signalObj;
}

function filterVictimDataListBySelected(victimDataList, selectedVictimSignals) {
  if (!victimDataList || !victimDataList.Waveform || !victimDataList.Waveform.list || !victimDataList.Waveform.list.length) {
    return victimDataList;
  }

  return {
    Waveform: {
      ...victimDataList.Waveform,
      list: victimDataList.Waveform.list.filter(item => selectedVictimSignals.includes(item.id))
    }
  }
}

export {
  getSignalNameObjByVerificationJson,
  filterVictimDataListBySelected
}